export const LOADING_TIPS = [
  "Consulting the ancient scrolls...",
  "Summoning mystical entities...",
  "Weaving threads of fate...",
  "Rolling cosmic dice...",
  "Brewing destiny's potion...",
  "Awakening slumbering gods...",
  "Charting unexplored territories...",
  "Whispering to the void...",
  "Aligning celestial bodies...",
  "Forging legendary artifacts...",
  "Reading the stars...",
  "Invoking primordial forces...",
  "Painting reality's canvas...",
  "Tuning the strings of fate...",
  "Gathering narrative threads...",
  "Consulting the oracle...",
  "Decoding ancient prophecies...",
  "Breathing life into shadows...",
  "Stirring the cauldron of possibilities...",
  "Channeling creative chaos..."
];

export function getRandomTip(): string {
  return LOADING_TIPS[Math.floor(Math.random() * LOADING_TIPS.length)];
}

export function getEstimatedTime(step: string): number {
  const times: { [key: string]: number } = {
    'world': 8,
    'character': 10,
    'portrait': 15,
    'background': 12,
    'event': 8
  };
  return times[step] || 10;
}
